<template>
  <div>
    <conversation-list
        v-loading="isBusy"
        ref="list"
        :index-url="indexUrl"
        :margin="16"
        @delete="onDelete"
        @edit="onEdit"
        @open-chat="onOpenChat"
        @move="onMove"
        :is-edit="isEditPage"
    >
    </conversation-list>
    <conversation-dialog
      v-bind="chatProps"
    ></conversation-dialog>
    <move-to-group-dialog :search-url="sendListSearchUrl"></move-to-group-dialog>
  </div>
</template>

<script>
  import ConversationList from "../../components/send-list/conversations/index";
  import eventBus from "../../event-bus";
  import ConversationDialog from "../send-list/list/conversation-dialog/dialog.vue";
  import {mapState} from "vuex";
  import StoreModule from '../../store/send-list-list-page';
  import MoveToGroupDialog from "../send-list/list/move-to-group-dialog";

  export default {
    props: {
      indexUrl: String,
      chatProps: Object,
      sendListSearchUrl: String,
      brandId: Number,
    },

    data() {
      return {
        isBusy: false,
      };
    },

    computed: {
      ...mapState('page', {excludedConversationIds: 'excludedConversationIds'}),

      /**
       * @return {boolean}
       */
      isEditPage() {
        return true;
      },
    },

    components: {
      ConversationDialog,
      'conversation-list': ConversationList,
      MoveToGroupDialog,
    },

    methods: {
      /**
       * @param {Object} item
       */
      onDelete(item) {
        this.$confirm('Do you confirm deleting?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })
          .then(() => this.deleteItem(item))
          .catch(() => {});
      },

      /**
       * @param {Object} item
       */
      onEdit(item) {
        eventBus.$emit('show-send-list-conversation-modal-form', {
          title: 'EDIT GROUP ITEM',
          url: _.get(item, 'edit_url'),
          model: {},
        })
      },

      /**
       * @param {Object} item
       */
      deleteItem(item) {
        this.isBusy = true;
        const url = _.get(item, 'destroy_url');
        if (url) {
          axios.delete(url)
            .then(({data: {message}}) => {
              this.$message.success(message);
              this.$refs.list.removeItemById(_.get(item, 'id'));
            })
            .finally(() => this.isBusy = false);
        }
      },

      /**
       * @return {undefined}
       */
      onSendListItemsUpdated() {
        this.$refs.list.refreshList();
      },

      /**
       * @param {object} payload
       */
      onOpenChat(payload) {
        eventBus.$emit('show-chat-dialog', payload);
      },

      /**
       * @param url
       */
      onMove(url) {
        eventBus.$emit('show-move-to-group-dialog', {
          url: url,
          brand_id: this.brandId,
        });
      },
    },

    beforeCreate() {
      this.$store.registerModule('page', StoreModule);
    },

    created() {
      eventBus.$on('send-list-items-updated', this.onSendListItemsUpdated);
    },

    beforeDestroy() {
      eventBus.$off('send-list-items-updated', this.onSendListItemsUpdated);
    },
  }
</script>

